// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__12gSI","dummyRightMenu":"styles_dummyRightMenu__etPi7","imgSkeleton":"styles_imgSkeleton__1Ea0e"};